const cardTypeOCR = {
  firstGeneration: 'First generation national ID',
  frontSecondGeneration: 'Front of second generation national ID',
  backSecondGeneration: 'Back of second generation national ID',
  chinaTemporary: 'China temporary national ID',
  bankCard: 'Bank Card',
};

export default cardTypeOCR;
